import React from 'react'
import { Image, Text } from '@chakra-ui/react'

import error from 'assets/images/error.svg'

import { HelpSupport } from 'components/HelpSupport'
import { InformativeLayer } from 'components/informativeLayer'

// IMPROVEMENT: los mensajes como estos podriamos meterlos en algun file aparte en base a las vistas o definirlos luego como un tech debt
export const messages = {
  title1: '¡Lo sentimos!',
  title2: 'En este momento no podemos continuar',
  subtitle: 'Podrás reintentar en las próximas horas desde nuestra página',
  support: '¿Tenés más consultas? Comunicate con Soporte',
  tel: '(011) 5554-2999',
}

const ErrorValidationAccountPage = () => {
  return (
    <div>
      <InformativeLayer
        title={
          <>
            <Text>{messages.title1}</Text>
            <Text>{messages.title2}</Text>
          </>
        }
        subtitle={<Text>{messages.subtitle}</Text>}
        Image={<Image src={error} alt='Lateral image' />}
        support={<HelpSupport line title={messages.support} tel={messages.tel} />}
      />
    </div>
  )
}

export default ErrorValidationAccountPage
